var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kst-page-edit',{attrs:{"autoValidate":""},on:{"init":_vm.handleInit,"submit":_vm.handleSubmit}},[_c('Details',{attrs:{"deliveryData":_vm.deliveryData,"userData":_vm.userData}}),_c('Delivery',{attrs:{"deliveryData":_vm.deliveryData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }